import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import "./ReactivityTagIa.scss";

import {fetchCategoryRoot, resetCategoryRoot} from "../../../../../../creators/category.rootChildrens";
import {Button} from "../../../../../components/Button";
import Icon from "../../../../../components/Icon";


class ReactivityTagIa extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categories : [],
            catNav : [],
            catSelect : []
        }

        this.props.fetchCategoryRoot(this.props.categorySlug, {sort : "order"}).then(response =>{
            let categories = response.payload.data || [];
            let categoriesLength = 0;
            if(categories.length){
                categoriesLength = categories.length;
            }

            let catNav =  categoriesLength === 4 ? categories : categories.slice(0,categoriesLength >=4 ? 2 : 3);
            let catSelect = categoriesLength === 4 ? [] : categories.slice(categoriesLength >=4 ? 2 : 3);
            this.setState({categories, catNav, catSelect});
        })
    }

    componentWillUnmount() {
        this.props.resetCategoryRoot()
    }

    handleCategory(categoryId){
        this.props.updateCategory(categoryId);
    }


    render() {
        let {
            categoryTitle = "",
            catIdSelected = {},
            isCheck = false
        } = this.props;
        let listIds = this.state.catSelect.map(item => item._id.toString());


        return (
            <div className="tag-moderations-qualification-medias-tags-ia">
                <p className={"inaccuracy"}>{categoryTitle} {isCheck ? <Icon className={"icon-success"} type={"check"} /> : null}</p>
                <div className={"btn-group"}>
                    {this.state.catNav.map(category =>(
                        <Button
                            key={category._id}
                            className={`${catIdSelected === category._id.toString() ? "category-success" : ""}`}
                            content={category.title}
                            onClick={()=>this.handleCategory(category._id)}
                        />
                    ))}
                    {this.state.catSelect.length ? (
                        <select
                            className={`${listIds.includes(catIdSelected) ? "category-success" : "" } select-categories`}
                            onChange={(event) => this.handleCategory(event.target.value)}
                            value={this.props.currentMediaCategory}
                        >
                            <option value={""} readOnly={true}>Autre</option>
                            {this.state.catSelect.map(category =>(
                                <option
                                    key={category._id}
                                    value={category._id}
                                    className={`${this.props.currentMediaCategory?.toString() === category._id.toString() ? "category-success" : ""}`}
                                >
                                    {category.title}
                                </option>
                            ))}
                        </select>
                    ) : null}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCategoryRoot,
    resetCategoryRoot
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReactivityTagIa);
